import { z } from 'zod';
import { defineFeature } from '../core/defineFeature.js';
import { FeatureType } from '../core/types.js';
const TabConfiguration = { id: 6, name: 'Tab Configuration' };
export const browserTabName = defineFeature({
    type: FeatureType.String,
    propName: 'browser_tab_name',
    uiName: 'browserTabName',
    displayName: 'Browser Tab Name',
    description: 'Configure browser tab name',
    category: TabConfiguration,
    areas: ['application'],
    codec: 'identity',
    schema: z.string(),
    default: '',
    isSystem: true,
    flatModelSchema: z.string().nullable(),
});
export const tabConfigurationFeatures = [browserTabName];
